import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-achievement-test-vocabulary',
  templateUrl: './program-achievement-test-vocabulary.component.html',
  styleUrls: ['./program-achievement-test-vocabulary.component.scss']
})
export class ProgramAchievementTestVocabularyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
